let baseUrl = "https://api-fitpass.in";
// let baseUrl = "https://api.fitpass.dev";
let razorpayId = "rzp_live_8r3vp2JYDFtUNK"; // for sbi yono
// let razorpayId = "rzp_live_pT5gMsYnkHTlOF";
// let razorpayPassword = "2fSXWgyOREtiHXs8GnGT6Z4J";
const razorPayScript = "https://checkout.razorpay.com/v1/checkout.js";
const cityOption = {
    "Agra": "Agra",
    "Ahmedabad": "Ahmedabad",
    "Amritsar": "Amritsar",
    "Bengaluru": "Bengaluru",
    "Bhopal": "Bhopal",
    "Bhubaneshwar": "Bhubaneshwar",
    "Chandigarh":"Chandigarh",
    "Chennai":"Chennai",
    "Coimbatore":"Coimbatore",
    "Dehradun":"Dehradun",
    "Delhi":"Delhi",
    "Faridabad":"Faridabad",
    "Ghaziabad":"Ghaziabad",
    "Gurugram":"Gurugram",
    "Guwahati":"Guwahati",
    "Hyderabad":"Hyderabad",
    "Indore":"Indore",
    "Jaipur":"Jaipur",
    "Jodhpur":"Jodhpur",
    "Kanpur":"Kanpur",
    "Kochi":"Kochi",
    "Kolkata":"Kolkata",
    "Lucknow":"Lucknow",
    "Ludhiana":"Ludhiana",
    "Madurai":"Madurai",
    "Mumbai":"Mumbai",
    "Noida":"Noida",
    "Patna":"Patna",
    "Pune":"Pune",
    "Raipur":"Raipur",
    "Ranchi":"Ranchi",
    "Shimla":"Shimla",
    "Surat":"Surat",
    "Udaipur":"Udaipur",
    "Vadodara":"Vadodara",
    "Delhi-NCR":"Delhi-NCR"
}

const genderOptions = {
    "Male": "Male",
    "Female": "Female"
}
export {
    baseUrl,
    razorPayScript,
    razorpayId,
    cityOption,
    // razorpayPassword,
    genderOptions
}
